import * as type from '../../types';

export function createCampaign(data) {
    return {
        type: type.FETCH_CREATE_CAMPAIGN,
        payload: data
    }
}